import { render, staticRenderFns } from "./ScaleController.vue?vue&type=template&id=2af1a2f6&scoped=true&"
import script from "./ScaleController.vue?vue&type=script&lang=js&"
export * from "./ScaleController.vue?vue&type=script&lang=js&"
import style0 from "./ScaleController.vue?vue&type=style&index=0&id=2af1a2f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af1a2f6",
  null
  
)

export default component.exports